import { memo } from "react";
import { SingleOption, useAdditionalOptions } from "../AdditionalOptions";
import { KYCServiceType, KYCSettingsServicePropertyName } from "consts/kyc";

const AdditionalOptions = () => {
    const { onChange, value } = useAdditionalOptions({
        kycTypeId: KYCServiceType.PhoneVerification
    });

    return (
        <SingleOption
            id='PhoneVerification-additional-options'
            options={[
                {
                    id: KYCSettingsServicePropertyName.IncludeIdVerifiedConsumers,
                    name: 'Include Verified Users'
                }
            ]}
            value={value}
            onChange={onChange}
        />
    );
};

export default memo(AdditionalOptions);
